import { LoggingService } from '@mxt/zio/logging'

export const POLogging = new LoggingService()
